import { ModalWrapper } from '@/components';
import LedgerForm from './LedgerForm';
import PropTypes from 'prop-types';

const LedgerModal = ({ isOpen, onClose, refreshLedgers, recruitingSeasonId } ) => {
  return (
    <ModalWrapper isOpened={isOpen} onCloseModal={onClose}>
      <LedgerForm
        onClose={onClose}
        refreshLedgers={refreshLedgers}
        recruitingSeasonId={recruitingSeasonId}
      />
    </ModalWrapper>
  );
};

LedgerModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  refreshLedgers: PropTypes.func,
  recruitingSeasonId: PropTypes.number,
};

export default LedgerModal;
